export default {
    namespaced: true,
    state: {
        companies: 1,
        users: 1
    },
    mutations: {
        setCompanies(state, companies) {
            Object.assign(state, { companies });
        },
        setUsers(state, users) {
            Object.assign(state, { users });
        }
    },
    actions: {}
}